<template>
  <div
    style="display: flex;flex-direction:column;justify-content: center;align-items: center"
  >
    <img src="../static/img/sh/益视说明书_00.png" alt="" />
    <img src="../static/img/sh/益视说明书_01.png" alt="" />
    <img src="../static/img/sh/益视说明书_02.png" alt="" />
    <img src="../static/img/sh/益视说明书_03.png" alt="" />
    <img src="../static/img/sh/益视说明书_04.png" alt="" />
    <img src="../static/img/sh/益视说明书_05.png" alt="" />
    <img src="../static/img/sh/益视说明书_06.png" alt="" />
    <img src="../static/img/sh/益视说明书_07.png" alt="" />
    <img src="../static/img/sh/益视说明书_08.png" alt="" />
    <img src="../static/img/sh/益视说明书_09.png" alt="" />
    <img src="../static/img/sh/益视说明书_10.png" alt="" />
    <img src="../static/img/sh/益视说明书_11.png" alt="" />
    <img src="../static/img/sh/益视说明书_12.png" alt="" />
    <img src="../static/img/sh/益视说明书_13.png" alt="" />
    <img src="../static/img/sh/益视说明书_14.png" alt="" />
    <img src="../static/img/sh/益视说明书_15.png" alt="" />
    <img src="../static/img/sh/益视说明书_16.png" alt="" />
    <img src="../static/img/sh/益视说明书_17.png" alt="" />
    <img src="../static/img/sh/益视说明书_18.png" alt="" />
    <img src="../static/img/sh/益视说明书_19.png" alt="" />
    <img src="../static/img/sh/益视说明书_20.png" alt="" />
    <img src="../static/img/sh/益视说明书_21.png" alt="" />
    <img src="../static/img/sh/益视说明书_22.png" alt="" />
    <img src="../static/img/sh/益视说明书_23.png" alt="" />
  </div>
</template>

<script>
export default {
  name: "sh"
};
</script>

<style scoped>
img {
  width: 900px;
}
</style>
